const formatCurrency = (
  value: number,
  options?: Intl.NumberFormatOptions,
  lng = 'ru-RU',
) => {
  return new Intl.NumberFormat(lng, {
    currency: 'RUB',
    maximumFractionDigits: 0,
    ...options,
  }).format(value);
};

export default formatCurrency;
